'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AlertDismiss;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/AlertDismiss.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AlertDismiss(_ref) {
  var handleDismiss = _ref.handleDismiss;

  return _react2.default.createElement(
    'button',
    {
      type: 'button',
      className: 'close cp-alert-dismiss',
      onClick: handleDismiss },
    _react2.default.createElement(
      _baseScreenReaderMessage2.default,
      null,
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close' })
    ),
    _react2.default.createElement(_baseIcons.Cross, null)
  );
}

AlertDismiss.propTypes = {
  handleDismiss: _react.PropTypes.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/dismiss/components/AlertDismiss.component.js
// module id = 1015
// module chunks = 1